
/**
 * 基于 axios 封装的请求模块
 */
import axios from 'axios'
import JSONbig from 'json-bigint'
import router from '@/router'
import qs from 'qs'

// 非组件模块可以这样加载使用 element 的 message 提示组件
// import { Message } from 'element-ui'


// axios()
// axios.get()
// axios.post()

// 创建一个 axios 实例，说白了就是复制了一个 axios
// 我们通过这个实例去发请求，把需要的配置配置给这个实例来处理
// var base_url = CONFIG.baseUrl
// if(base_url.indexOf('https:') == 0 && document.location.protocol != 'https:' && location.href.indexOf('//127.0.0.1') == -1 && location.href.indexOf('//localhost') == -1 && location.href.indexOf('//192.') == -1 && location.href.indexOf('//10.') == -1)
// {
//   base_url =  location.replace('https://'+location.href.substring(7));
// }
const request = axios.create({
  
//'http://web.fondcard.net/open/enterprise/services.php'
  // baseURL: "https://www.fondcard.net/open/", // 请求的基础路径
  baseURL: "https://web.fondcard.net/", // 请求的基础路径

  // 定义后端返回的原始数据的处理
  // 参数 data 就是后端返回的原始数据（未经处理的 JSON 格式字符串）
  transformResponse: [function (data) {
    // Do whatever you want to transform the data
    // console.log(data)

    // 后端返回的数据可能不是 JSON 格式字符串
    // 如果不是的话，那么 JSONbig.parse 调用就会报错
    // 所以我们使用 try-catch 来捕获异常，处理异常的发生
    try {
      // 如果转换成功，则直接把结果返回
      return JSONbig.parse(data)
    } catch (err) {
      console.log('转换失败', err)
      // 如果转换失败了，则进入这里
      // 我们在这里把数据原封不动的直接返回给请求使用
      return data
    }

    // axios 默认在内部使用 JSON.parse 来转换处理原始数据
    // return JSON.parse(data)
  }]
})

// 请求拦截器
request.interceptors.request.use(
  // 任何所有请求会经过这里
  // config 是当前请求相关的配置信息对象
  // config 是可以修改的
  function (config) {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    return config
  },
  // 请求失败，会经过这里
  function (error) {
    return Promise.reject(error)
  }
)

// 响应拦截器
// Add a response interceptor
request.interceptors.response.use(function (response) {
  // 所有响应码为 2xx 的响应都会进入这里

  // response 是响应处理
  // 注意：一定要把响应结果 return，否则真正发请求的位置拿不到数据
  return response
}, function (error) {
  const { status } = error.response
  // 任何超出 2xx 的响应码都会进入这里
  if (status === 401) {
    // 跳转到登录页面
    // 清除本地存储中的用户登录状态
    window.localStorage.removeItem('user')
    router.push('/login')
    // Message.error('登录状态无效，请重新登录')
  } else if (status === 403) {
    // token 未携带或已过期
    // Message({
    //   type: 'warning',
    //   message: '没有操作权限'
    // })
  } else if (status === 400) {
    // 客户端参数错误
    // Message.error('参数错误，请检查请求参数')
  } else if (status == '-100') {
    // Message.error('系统正在维护，请稍后重试')
    router.push('/login')
  }

  return Promise.reject(error)
})

// 导出请求方法
export default request

// 谁要使用谁就加载 request 模块
// import request from 'request.js'
// request.xxx
// request({
//   method: ,
//   url: ''
// })

// import axios from 'axios'
// import qs from 'qs'
// var baseURL = ''
// const instance = axios.create({
//   baseURL:baseURL,
//   timeout: 3000,
// });

// // 添加请求拦截器
// instance.interceptors.request.use(function (config) {
//   console.log(`908`,config)
//   // 在发送请求之前做些什么
//   if (config.method === 'post')
//   {
//     config.data = qs.stringify(config.data)
//   }
//   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
//   return config;
// }, function (error) {
  
//   // 对请求错误做些什么
//   return Promise.reject(error);
// });



// // 添加响应拦截器
// instance.interceptors.response.use(function (response) {
//   // 2xx 范围内的状态码都会触发该函数。
//   // 对响应数据做点什么
//   return response;
// }, function (error) {
//   console.log(`909`,error)
//   // 超出 2xx 范围的状态码都会触发该函数。
//   // 对响应错误做点什么
//   return Promise.reject(error);
// });

// export default instance